import { render, staticRenderFns } from "./VGlobalSearchModal.vue?vue&type=template&id=3c005014&scoped=true"
import script from "./VGlobalSearchModal.vue?vue&type=script&lang=js"
export * from "./VGlobalSearchModal.vue?vue&type=script&lang=js"
import style0 from "./VGlobalSearchModal.vue?vue&type=style&index=0&id=3c005014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c005014",
  null
  
)

export default component.exports